import './BarLabelOverlay.css';
export var labelSpan = '_b76tm81-3-12-1';
export var overlayContainer = '_b76tm80-3-12-1';